export const envToBool = (value: string | undefined | null) => (!value ? false : /^true/i.test(value))

export function randomChar(length: number) {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ%&$#?!0123456789'

  for (let i = 0; i < length; i++) {
    const randomInd = Math.floor(Math.random() * characters.length)
    result += characters.charAt(randomInd)
  }

  return result
}
